import loginBg from '@/assets/login-bg.png';
import Grid2 from '@mui/material/Grid2';
import { MockupDevices } from './mockup_devices';
import { SignInForm } from './sign_in_form';

const SignInPage = () => {
  return (
    <Grid2
      container
      size={12}
      sx={{
        overflow: 'hidden',
        backgroundImage: `url(${loginBg})`,
        backgroundPosition: 'right 0px',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <SignInForm />
      <MockupDevices />
    </Grid2>
  );
};

export default SignInPage;
